{
  "production": {
    "host": "sertec-api.endpoints.fal-corp-stro-posvnt-prod.cloud.goog"
  },
  "uat": {
    "host": "sertec-api.endpoints.fal-corp-stro-posvnt-uat.cloud.goog"
  },
  "dev": {
    "host": "sertec-api-dev.endpoints.fal-corp-stro-posvnt-uat.cloud.goog"
  }
}
